import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestBondFormQueryKey } from "../bond-request.keys";

export type BondFormQueryState = {
	data: Dtos.Admin.SuretyBondForm.Get.Response | undefined;
	error: Error | null;
	isFetching: boolean;
	isLoading: boolean;
	refetch: () => void;
};

export const useFetchAdminQuoteBondForm = (
	accountId: SuretyAccountId,
	quoteId: SuretyQuoteId,
): BondFormQueryState => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: bondRequestBondFormQueryKey(quoteId),
		queryFn: async () =>
			await get<Dtos.Admin.SuretyBondForm.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/bond-form`,
			),
		retry: false,
		// The bond form tab renders its own error state with a retry, so the global modal would
		// double up on a failure the user can already see and recover from.
		meta: { suppressErrorModal: true },
	});

	return {
		data,
		error,
		isFetching,
		isLoading,
		refetch,
	};
};
